;(function ($, window, document, undefined) {
    "use strict";

    const pluginName = "aganMobilemenu",
        defaults = {
            burgerMenuSelector: '.header-burger-icon',
            burgerMenuOpenClass: 'header-burger-icon--open',
            mobileMenuSelector: '#mobilemenu',
            closeOnOrientationChange: false,
            orientationChangeBreakpoint: "(min-width: 786px)",
            mobileMenuCloseIcon: '.mobilemenu-close-icon'
        };

    /**
     * Constructor
     * @param element
     * @param options
     * @constructor
     */
    function Plugin(element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.mobileMenuHTMLCode = "";
        this.mobileMenuIsOpen = false;

        this._$element = $(this.element);
        this._controller = new slidebars();

        this.init();
    }

    $.extend(Plugin.prototype, {

        /**
         * jquery constructor
         */
        init: function () {
            this._controller.init();
            this._bindBurgerMenuEvent();
            this._bindCloseIconEvent();
            this._bindCanvasEvents();
            this._bindMenuItemToggle();
            this._loadMobileMenuHTML();

            if (this.settings.closeOnOrientationChange) {
                this._bindOrientationChangeEvent();
            }
        },

        /**
         * @private
         */
        _closeMobileMenu: function () {
            $(this.settings.burgerMenuSelector).removeClass(this.settings.burgerMenuOpenClass);
            $('body').removeClass('mobilemenu--open');
            this._controller.close('agan-slidebar');
        },

        /**
         * @private
         */
        _bindOrientationChangeEvent: function () {
            const self = this;
            window.addEventListener("orientationchange", function () {
                window.setTimeout(function () {
                    if (window.matchMedia(self.settings.orientationChangeBreakpoint).matches) {
                        self._closeMobileMenu();
                    }
                }, 50);
            });
        },

        /**
         * @private
         */
        _bindBurgerMenuEvent: function () {
            const self = this;
            $(this.settings.burgerMenuSelector).on('click tap', function (event) {
                event.stopPropagation();
                event.preventDefault();

                // toggle slidebar
                self._injectMobileMenuHTML();
                $(this).toggleClass(self.settings.burgerMenuOpenClass);
                $('body').toggleClass('mobilemenu--open');
                self._controller.toggle('agan-slidebar');
                self.mobileMenuIsOpen = !self.mobileMenuIsOpen;
            });
        },

        /**
         * @private
         */
        _bindCloseIconEvent: function () {
            const self = this;
            $(this.settings.mobileMenuCloseIcon).on('click tap', function (event) {
                self._closeMobileMenu();
            });
        },

        /**
         * @private
         */
        _bindCanvasEvents: function () {
            const self = this;
            $('[canvas="container"]').on('click', function () {
                self._closeMobileMenu();
            });
        },
        /**
         * @private
         */
        _loadMobileMenuHTML: function () {
            const self = this;
            $.get('/?cl=tpl&tpl=ajax_mobilenavigation_mobilemenu_widget.tpl', function (oData, sStatus, oXhr) {
                self.mobileMenuHTMLCode = oData;
                if (self.mobileMenuIsOpen) {
                    self._injectMobileMenuHTML();
                }
            });
        },

        /**
         * @private
         */
        _injectMobileMenuHTML: function () {
            const self = this;
            const alreadyInjectedClass = "menu-injected";
            const mobileMenuContainer = $(self.settings.mobileMenuSelector);

            if (!mobileMenuContainer.hasClass(alreadyInjectedClass) && self.mobileMenuHTMLCode != "") {
                mobileMenuContainer.append(self.mobileMenuHTMLCode);
                mobileMenuContainer.addClass(alreadyInjectedClass);
            }
        },

        /**
         * @private
         */
        _bindMenuItemToggle: function () {
            this._$element.on('click tap', '.mobilemenu-item .mobilemenu-item-arrow', function (event) {

                const $menuitem = $(event.currentTarget).closest(".mobilemenu-item");
                const $menuitemSiblings = $menuitem.parent().siblings();

                event.preventDefault();

                $menuitemSiblings.find('a').removeClass('open');
                $menuitemSiblings.find('ul').slideUp(200);

                if ($menuitem.hasClass('open')) {
                    $menuitem.next('ul').slideUp(200);
                } else {
                    $menuitem.next('ul').slideToggle(200, () => {
                        $menuitem[0].scrollIntoView({behavior: "smooth"});
                    });
                }

                $menuitem.toggleClass('open');
            });
        }
    });

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" +
                    pluginName, new Plugin(this, options));
            }
        });
    };

})(jQuery, window, document);
